import { render, staticRenderFns } from "./NphAutoAccident.vue?vue&type=template&id=93f1bb4a&scoped=true"
import script from "./NphAutoAccident.vue?vue&type=script&lang=js"
export * from "./NphAutoAccident.vue?vue&type=script&lang=js"
import style0 from "./NphAutoAccident.vue?vue&type=style&index=0&id=93f1bb4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f1bb4a",
  null
  
)

export default component.exports